module.exports = __webpack_public_path__ + "static/img/products application_redmud2.7a9e86a3.jpg";